import { useState } from "react";

const MODULES = [
  {
    icon: "ri-user-settings-line",
    title: "User Management",
    description: "Handle directory and access",
    href: "/admin/panel/users",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "Roles & Permissions",
    description: "Define security policies",
    href: "#",
  },
  {
    icon: "ri-contacts-book-2-line",
    title: "Account Management",
    description: "Manage system accounts",
    href: "/admin/panel/accounts",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "Cost Categories",
    description: "Define cost types and categories",
    href: "/admin/panel/cost-categories",
  },
];

const ModuleCard = ({ icon, title, description, href }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href={href}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        padding: 32,
        borderRadius: 16,
        border: "1px solid #f0f4ff",
        background: hovered ? "#002045" : "white",
        boxShadow: hovered ? "0 12px 32px rgba(0,32,69,0.18)" : "0 4px 20px -4px rgba(0,0,0,0.05)",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        transition: "all 0.2s ease",
        textDecoration: "none",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          width: 64, height: 64, borderRadius: "50%",
          background: hovered ? "rgba(255,255,255,0.15)" : "#dce8ff",
          display: "flex", alignItems: "center", justifyContent: "center",
          marginBottom: 16, transition: "background 0.2s ease",
        }}
      >
        <i className={icon} style={{ fontSize: 28, color: hovered ? "white" : "#002045" }} />
      </div>
      <h6
        style={{
          fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase",
          letterSpacing: "0.08em", color: hovered ? "white" : "#002045",
          marginBottom: 8, transition: "color 0.2s ease",
        }}
      >
        {title}
      </h6>
      <p style={{ fontSize: "0.75rem", color: hovered ? "rgba(255,255,255,0.7)" : "#6b7280", margin: 0, transition: "color 0.2s ease" }}>
        {description}
      </p>
    </a>
  );
};

const AdminModules = () => (
  <div className="mb-5">
    <div className="d-flex align-items-center justify-content-between mb-4">
      <h5 className="fw-bold mb-0 d-flex align-items-center gap-2" style={{ color: "#002045" }}>
        <i className="ri-layout-grid-line" />
        Admin Modules
      </h5>
      <span className="text-muted small fw-medium">Quick access to core system tools</span>
    </div>

    <div className="row g-4">
      {MODULES.map((mod, i) => (
        <div key={i} className="col-12 col-md-6 col-lg-3">
          <ModuleCard {...mod} />
        </div>
      ))}
    </div>
  </div>
);

export default AdminModules;
